import { useCallback, useRef, useEffect } from 'react';
/**
 * 获取上一个值
 * @param value 需要获取的值
 */
export const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};
/**
 * 模拟componentDidMount
 * @param fn callback function
 */
export const useMount = (fn) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(fn, []);
};
export default useMount;
/**
 * 模拟componentDidUpdate
 * @param fn 回调函数
 * @param deps
 */
export function useUpdate(fn, deps = []) {
    const mounted = useRef(false);
    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true;
        }
        else {
            fn();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
/**
 * 监听页面变化
 * @param callback 回调函数
 */
export const useRouteChange = (callback) => {
    const handleRouteChange = useCallback((e) => {
        callback && callback(e);
    }, [callback]);
    useEffect(() => {
        window.addEventListener('hashchange', handleRouteChange);
        window.addEventListener('popstate', handleRouteChange);
        return () => {
            window.removeEventListener('hashchange', handleRouteChange);
            window.removeEventListener('popstate', handleRouteChange);
        };
    }, [handleRouteChange]);
};
